import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login.vue";
import AppSumo from "@/views/AppSumo.vue";
import Project from "@/views/Board.vue";
import BoardLayout from "@/views/MainBoardLayout.vue";
import TimeTable from "@/views/TimeTable.vue";
import SmartList from "@/views/SmartList.vue";
import APIKeys from "@/views/APIKeys.vue";
import Members from "@/views/Members.vue";
import AllActivities from "@/views/AllActivities.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: BoardLayout,
        props: route => ({ token: route.query.token }),
        children: [
            {
                path: "project/:board_id",
                name: "Project",
                component: Project,
                props: true,
            },
            {
                path: "tasks/:taskInfo",
                name: "TaskModal",
                component: Project,
                props: true
            },
            {
                path: "timetable/:board_id",
                name: "TimeTable",
                component: TimeTable,
                props: true
            },
            {
                path: "smart-board/:board_id",
                name: "SmartList",
                component: SmartList,
                props: true  
            },
            {
                path: "all-activities",
                name: "Activities",
                component: AllActivities,
                props: true  
            },
            {
                path: "api-keys/:board_id",
                name: "APIKeys",
                component: APIKeys,
                props: true  
            },
            {
                path: "members/:board_id",
                name: "Members",
                component: Members,
                props: true  
            },
            {
                path: "board/:board_id",
                redirect: (to) => {
                  return `project/${to.params.board_id}`;
                },
            },
        ]
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        props: true
    },
    {
        path: "/sumo",
        name: "AppSumo",
        component: AppSumo,
        props: true
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.path === '/login' && localStorage.getItem('token')) {
        next('/')
    } else if (to.path !== '/login' && to.path.toLowerCase() !== '/sumo' && !localStorage.getItem('token') && !to.query.tmp_code) {
        next('/login')
    } else {
        next()
    }
})

export default router;
